import AttestationMotif from '@/generated/controls/attestation/AttestationMotif.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AttestationMotif
})
